import { useState, useEffect } from 'react';
import { getModelVersionRoles } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useRoles = (modelVersionId, showAll = true) => {
  const dispatch = useDispatch();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const loadRoles = async () => {
      if (!modelVersionId) {
        setRoles([]);
        return;
      }

      try {
        const response = await getModelVersionRoles({ 
          modelVersionId 
        });
        
        let updatedRoles = [];
        if (response?.status) {
          const fetchedRoles = response.data || [];
          updatedRoles = (showAll && fetchedRoles.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedRoles]
            : fetchedRoles;
        }
        setRoles(updatedRoles);
      } catch (error) {
        dispatch(showError('Failed to load roles'));
        setRoles([]);
      }
    };
    
    loadRoles();
  }, [modelVersionId, showAll]);

  return roles;
}; 